// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 436 ? "__federation_expose_Categories" : chunkId) + "." + {"68":"f15c0ce01e9dcd45aab1","327":"0ab85c7dfba514063f02","385":"c59f212182928fda8045","436":"998b83ce84acf9221d87","627":"b5aa225d7a4801cd2d15","708":"0c81287085ce18d00928","819":"0f12d7c1083bc7c21d2b","979":"426c386220e7b6da8c30"}[chunkId] + ".js";
};